<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-calendar-circle-exclamation', fontSet: 'fad'}"
	[headerText]="T.BLOCKING_SESSIONS_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		@if (sessions().length) {
			<sim-warning-message [text]="T.BLOCKING_SESSIONS_DIALOG_WARNING_MSG" />
			<div class="scrollViewport">
				@for (session of sessions(); track session.id) {
					<sim-session-card [session]="session" [creationMode]="true">
						<ng-container actions>
							<sim-button
								color="warn"
								(click)="cancelSession(session.id)"
								[appBusy]="busyMap().get(session.id)"
								[icon]="{fontIcon: 'fa-stop', fontSet: 'fas'}"
								[label]="T.EVENT_SESSION_EXAM_SESSION_ABORT_SESSION_BTN_TXT"
							/>
						</ng-container>
					</sim-session-card>
				}
			</div>
		} @else {
			<div class="emptyState" [@zoomInOnEnter]>
				<mat-icon fontIcon="fa-thumbs-up" fontSet="fad" />
				<p>{{ T.BLOCKING_SESSION_DIALOG_EMPTY_STATE | translate }}</p>
			</div>
		}
	</ng-container>
	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontIcon: 'fa-check', fontSet: 'fas'}" [label]="T.BUTTON_FINISH" />
	</ng-container>
</sim-basic-material-dialog>
